import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CourseRepositoryService } from '../../../courses/services/course-repository.service';
import { CourseEntity, LessonTypeAllItems, StudentCourseEntity } from '../../../../meta-data/app-meta-data.service';
import { TreeNode } from 'primeng/api';
import { combineLatest, Observable, of } from 'rxjs';
import { finalize } from 'rxjs/operators';
@Component({
  selector: 'app-lesson-selection-tree-control',
  templateUrl: './lesson-selection-tree-control.component.html',
  styleUrls: ['./lesson-selection-tree-control.component.scss']
})
export class LessonSelectionTreeControlComponent implements OnInit {


  @Input() courseId: number;

  @Input() selectedLessonIds: number[];
  @Output() selectedLessonIdsChange = new EventEmitter<number[]>();

  @Input() studentId: number;
  @Input() showStudentProgress: boolean = false;

  course: CourseEntity;

  treeData: TreeNode[] = [];

  selectedNodes: TreeNode[] = [];
  studentCourse: StudentCourseEntity;

  studentCourseCache: { [key: number]: StudentCourseEntity } = {};


  constructor(private courseRepositoryService: CourseRepositoryService) { }

  ngOnInit(): void {
    // this.loadCourse();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.courseId || changes.studentId || changes.showStudentProgress) {
      this.loadCourse();
    }
    if (changes.selectedLessonIds) {
      this.updateSelectedNodes();
    }
  }

  updateSelectedNodes(expandNodes: boolean = false) {
    const selectedNodes: TreeNode[] = [];

    for (var moduleNode of this.treeData) {
      let allSelected = true;
      let anySelected = false;
      for (var lessonNode of moduleNode.children) {
        if (this.selectedLessonIds?.includes(lessonNode.data)) {
          selectedNodes.push(lessonNode);
          anySelected = true;
        } else {
          allSelected = false;
        }
      }
      if (allSelected) {
        selectedNodes.push(moduleNode);
      }

      if (anySelected && expandNodes) {
        moduleNode.expanded = true;
      }
    }

    this.selectedNodes = selectedNodes;
  }

  nodeSelect(event: any) {
    const lessonIds: number[] = [];

    for (var node of this.selectedNodes) {
      if (node.type == 'lesson') {
        lessonIds.push(node.data);
      }
    }

    this.selectedLessonIds = lessonIds;
    this.selectedLessonIdsChange.emit(this.selectedLessonIds);
  }

  loadingCourseData: boolean = false;
  courseDataChanges: boolean = false;
  private loadCourse() {

    if (!this.courseId) {
      return;
    }

    if (this.loadingCourseData) {
      this.courseDataChanges = true;
      return;
    }

    this.loadingCourseData = true;

    const obs: Observable<any>[] = [];

    let courseOb = of(this.course);

    if (this.courseId && this.courseId != this.course?.CourseId) {
      courseOb = this.courseRepositoryService.getCourseHierarchy(this.courseId);
    }

    obs.push(courseOb);

    let studentCourseOb = of(this.studentCourse);

    if (this.showStudentProgress) {
      if (this.studentCourse?.StudentId != this.studentId || this.studentCourse?.CourseId != this.courseId) {

        if (this.studentId) {
          const key = `${this.studentId}-${this.courseId}`;

          // Check cache first - this was added to prevent a ton of database calls if they keep toggling students
          if (this.studentCourseCache[key]) {
            studentCourseOb = of(this.studentCourseCache[key]);
          } else {
            studentCourseOb = this.courseRepositoryService.loadStudentCourseWithProgressAdmin(this.courseId, this.studentId);
          }

        } else {
          studentCourseOb = of(null);
        }
      }
    } else {
      studentCourseOb = of(null);
    }

    obs.push(studentCourseOb);

    combineLatest(obs).pipe(finalize(() => {
      this.loadingCourseData = false;
      if (this.courseDataChanges) {
        this.courseDataChanges = false;
        this.loadCourse();
      }
    })).subscribe(([course, studentCourse]) => {
      this.course = course;
      this.studentCourse = studentCourse;

      if (this.studentCourse) {
        // Add student course to cache
        const key = `${this.studentCourse.StudentId}-${this.studentCourse.CourseId}`;
        this.studentCourseCache[key] = this.studentCourse;
      }

      this.buildTree();
    });
  }

  // private loadStudentCourseProgress() {
  //   if (!this.showStudentProgress || !this.studentId || !this.course) {
  //     return;
  //   }

  //   if (this.studentCourse?.StudentId == this.studentId && this.studentCourse?.CourseId == this.courseId) {
  //     return;
  //   }

  //   this.courseRepositoryService.loadStudentCourseWithProgressAdmin(this.studentId, this.courseId)
  //     .subscribe(studentCourse => {
  //       this.studentCourse = studentCourse;

  //       this.buildTree();
  //     });
  // }

  buildTree() {
    this.treeData = [];
    this.selectedNodes = [];
    if (!this.course) {
      return;
    }

    let expandedNodeSet = false;

    for (let module of this.course.CourseModule) {
      const moduleNode: TreeNode = {
        label: module.ModuleName,
        data: module.CourseModuleId,
        type: 'module',
        expanded: false,
        children: [],
        icon: 'fa fa-book'
      };

      (moduleNode as any).key = 'module-' + module.CourseModuleId;

      const moduleprogress = this.studentCourse?.CourseModuleProgress?.find(mp => mp.CourseModuleId == module.CourseModuleId);

      if (moduleprogress?.PercentComplete >= 100) {
        moduleNode.icon = 'fa fa-check-circle dw-green'
      } else if (moduleprogress?.PercentComplete > 0) {
        moduleNode.icon = 'fa fa-book dw-orange'
      }

       if (!expandedNodeSet && moduleprogress?.PercentComplete < 100) {
          moduleNode.expanded = true;
          expandedNodeSet = true;
        }

      this.treeData.push(moduleNode);

      for (let lesson of module.CourseLesson) {
        const lessonNode: TreeNode = {
          label: lesson.LessonName,
          data: lesson.CourseLessonId,
          type: 'lesson',
          expanded: false,
          children: [],
          icon: lesson.LessonTypeId == LessonTypeAllItems.Quiz ? 'fa fa-list-alt dw-grey' : 'fa fa-play-circle dw-grey'
        };

        (lessonNode as any).key = 'lesson-' + lesson.CourseLessonId;

        const lessonProgress = moduleprogress?.CourseLessonProgress?.find(mp => mp.CourseLessonId == lesson.CourseLessonId);

        if (lessonProgress) {
          if (lessonProgress?.PercentComplete >= 100) {
            lessonNode.icon = 'fa fa-check-circle dw-green'
          }
          switch (lesson.LessonTypeId) {
            case LessonTypeAllItems.Video:
              if (lessonProgress.VideoFurthestTimeSeconds > 0 && lessonProgress?.PercentComplete < 100) {
                lessonNode.icon = 'fa fa-play-circle dw-orange'
              }

              break;
            case LessonTypeAllItems.Quiz:
              const attempCount = lessonProgress.QuizResult?.length || 0;

              lessonNode.label += ` (Attempts: ${attempCount})`;

              if (lessonProgress.LessonComplete) {
                lessonNode.icon = 'fa fa-list-alt dw-green'
              } else if (attempCount > 1) {
                lessonNode.icon = 'fa fa-list-alt dw-orange'
              }
              break;
          }
        }

        moduleNode.children.push(lessonNode);
      }

    }

    this.updateSelectedNodes(true);
  }
}
